import * as React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { DragSource } from 'react-dnd';

import getEmptyImage from 'react-dnd-html5-backend/lib/esm/getEmptyImage';
import { ReferenceFactory } from 'domain/journal/helper';
import { clearReferenceAction, setRefernceAction } from 'domain/journal';
import { nanoid } from 'nanoid';

import { GridActionIcon } from 'pages/document/page/components/Grid/StyledComponents';
import TouchAppRoundedIcon from '@mui/icons-material/TouchAppRounded';

class DragButton extends React.Component {
  componentDidMount() {
    const { dragPreview } = this.props;
    dragPreview(getEmptyImage(), { captureDraggingState: false });
  }

  setSelfRef = (buttonRef) => {
    this.buttonRef = buttonRef;
  };

  buttonRef;

  render() {
    const { moveGridPosition, dragSource } = this.props;
    return dragSource(
      <div>
        <GridActionIcon color="primary" style={moveGridPosition} ref={this.setSelfRef}>
          <TouchAppRoundedIcon />
        </GridActionIcon>
      </div>,
    );
  }
}

let referenceId;

const gridSource = {
  beginDrag: (props, monitor, component) => {
    const { left, width, top, height } = component.buttonRef.getBoundingClientRect();
    const { structure, setReference, getStyledPolygons } = props;
    referenceId = nanoid(10);
    const params = ReferenceFactory({
      id: referenceId,
      x1: left + width / 1.8,
      y1: top + height / 1.8 + window.scrollY,
      type: 'GRID',
    });
    setReference({ params, id: referenceId });
    return { type: 'GRID', payload: { grid: structure, polygons: getStyledPolygons() } };
  },

  endDrag(props) {
    props.clearReference();
  },
};

function collect(connector) {
  return {
    dragSource: connector.dragSource(),
    dragPreview: connector.dragPreview(),
  };
}

const mapDispatchToProps = {
  setReference: setRefernceAction,
  clearReference: clearReferenceAction,
};

export default compose(connect(null, mapDispatchToProps), DragSource('Polygon', gridSource, collect))(DragButton);
